import * as yup from "yup";

import { IEditDeveloperSettings } from "../../interfaces-and-types";

export const devSettingsValidationSchema: yup.SchemaOf<IEditDeveloperSettings> =
  yup
    .object({
      live_webhook_url: yup
        .string()
        .url("Please enter a valid URL")
        .nullable()
        .optional(),
      test_webhook_url: yup
        .string()
        .url("Please enter a valid URL")
        .nullable()
        .optional(),

      live_redirect_url: yup
        .string()
        .url("Please enter a valid URL")
        .nullable()
        .optional(),
      test_redirect_url: yup
        .string()
        .url("Please enter a valid URL")
        .nullable()
        .optional(),
    })
    .required();
